import { css } from '@/styled-system/css';

export const wrapper = css({
  background: 'bg.neutral',
  paddingTop: 'loose',
  paddingBottom: 'default',
  md: {
    paddingTop: 'looser',
    paddingBottom: 'loose',
  },
});

export const collectionSection = css({
  // eslint-disable-next-line hotpads/no-magic-numbers -- design-specific dimension; follow-up tokenization
  maxWidth: '1152px',
  marginInline: 'auto',
  paddingInline: 'default',
  '& + &': {
    marginTop: 'looser',
  },
});

export const header = css({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  marginBottom: 'default',
});

export const heading = css.raw({
  margin: 0,
  md: {
    textStyle: 'heading-sm',
  },
});

export const headingSkeleton = css({
  // eslint-disable-next-line hotpads/no-magic-numbers -- C11n has no semantic size token for this content placeholder width
  width: '200px',
  height: 'obj.xs',
  md: {
    height: 'obj.sm',
  },
});

export const seeAllLink = css({
  display: 'none',
  alignItems: 'center',
  gap: 'tightest',
  fontSize: 'body-sm',
  fontWeight: 'bold',
  color: 'brand.primary',
  textDecoration: 'none',
  whiteSpace: 'nowrap',

  flexShrink: 0,
  _hover: {
    textDecoration: 'underline',
  },
  md: {
    display: 'inline-flex',
  },
});

// paddingBlock mirrors the resolved Carousel viewport's vertical chrome (measured 16px each side) — keep in sync or the skeleton swap shifts (CLS).
export const skeletonRail = css({
  display: 'flex',
  gap: 'loose',
  overflow: 'hidden',
  paddingBlockStart: 'default',
  paddingBlockEnd: 'default',
});
